var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper",style:(_vm.parentStyle)},[_c('v-icon',{staticClass:"base-icon",style:(_vm.iconStyle),attrs:{"color":_vm.color,"ripple":_vm.ripple},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.validIcon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }